import { n as e } from "./PortalContainerContext-Cz7eWR3N.js";
import { BULK_UPDATE_DELAY as t, CUSTOM_LAST_MODIFIED_FORMAT as n, DEFAULT_PAGE_SIZE as r, FilterType as i, STATUS_BACKGROUND_COLOR as a, SseMessageType as o, SseTaskEventType as s, SseTaskMessageType as c, StatusEnum as l, TABLE_PAGE_SIZE_SELECTOR as u, TASK_ACTION_LABELS as d, TaskActions as f, config as p, fetchBulkAssignees as m, fetchTaskAssignees as h, fetchTaskComments as g, fetchTaskHistory as _, fetchViewTask as v, fetchViewTasks as y, getEventDescriptionHtml as b, getFilterOperator as x, getFilterOptions as S, getFilterValue as C, getLocalizedRelativeTime as w, getOverrideDateFormatter as T, getPossibleBulkActions as E, getProcessUrl as ee, getTaskManagerResources as D, initSseConnection as O, localizeString as k, localizeTemplateText as A, removeComment as te, resetTaskManagerStores as j, resolveConnectionOptions as M, saveComment as N, setAccessToken as P, sortedColumnState as F, taskManagerAnalytics as ne, toViewTasksSorts as I, transformUsersToOptions as L, updateBulkTaskAction as re, updateTaskAction as ie, updateTaskPriority as R } from "@flowx/core-sdk";
import { Fragment as ae, useCallback as z, useEffect as B, useLayoutEffect as V, useMemo as H, useReducer as oe, useRef as U, useState as W } from "react";
import { clsx as G } from "clsx";
import { ThemeComponent as K } from "@flowx/core-theme";
import { getThemingClassName as q, useCustomStyles as J } from "@flowx/react-theme";
import { FlxButton as Y, FlxCard as se, FlxCheckbox as ce, FlxChoiceGroupContainer as le, FlxIcon as ue, FlxInput as de, FlxInputContainer as fe, FlxInputField as X, FlxModal as pe, FlxSelect as me, FlxSelectContainer as he, FlxSelectOption as ge, FlxSpinner as _e, MemoFlxButton as ve, MemoFlxCheckboxGroup as ye, MemoFlxIcon as Z, MemoFlxInput as be, MemoFlxInputContainer as xe, MemoFlxRadio as Se, MemoFlxRadioGroup as Ce, MemoFlxSelectOption as we, MemoFlxTable as Te } from "@flowx/react-ui-toolkit";
import { Fragment as Ee, jsx as Q, jsxs as $ } from "react/jsx-runtime";
import { debounce as De, isEqual as Oe, isObject as ke, parseInt as Ae } from "lodash";
import { useGridFilter as je } from "ag-grid-react";
import { AG_GRID_LOCALE_BG as Me, AG_GRID_LOCALE_CN as Ne, AG_GRID_LOCALE_CZ as Pe, AG_GRID_LOCALE_DE as Fe, AG_GRID_LOCALE_DK as Ie, AG_GRID_LOCALE_EG as Le, AG_GRID_LOCALE_ES as Re, AG_GRID_LOCALE_FI as ze, AG_GRID_LOCALE_FR as Be, AG_GRID_LOCALE_GR as Ve, AG_GRID_LOCALE_HR as He, AG_GRID_LOCALE_HU as Ue, AG_GRID_LOCALE_IL as We, AG_GRID_LOCALE_IR as Ge, AG_GRID_LOCALE_IT as Ke, AG_GRID_LOCALE_JP as qe, AG_GRID_LOCALE_KR as Je, AG_GRID_LOCALE_NL as Ye, AG_GRID_LOCALE_NO as Xe, AG_GRID_LOCALE_PK as Ze, AG_GRID_LOCALE_PL as Qe, AG_GRID_LOCALE_PT as $e, AG_GRID_LOCALE_SE as et, AG_GRID_LOCALE_SK as tt, AG_GRID_LOCALE_TR as nt, AG_GRID_LOCALE_UA as rt, AG_GRID_LOCALE_VN as it } from "@ag-grid-community/locale";
import './FlxTaskManager.css';//#region libs/sdk/react/src/lib/utils/deprecated-props.ts
var at = (e) => {
	let t = M(e);
	return {
		...t,
		apiUrl: t.apiUrl,
		staticAssetsPath: t.staticAssetsPath
	};
}, ot = ({ model: e, onModelChange: t, colDef: n, context: r, getValue: i, api: a }) => {
	let o = U(null), [s, c] = W(e?.filter), l = a.getGridOption("localeText"), u = q(K.Radio), d = z(({ data: e }) => {
		let t = i(e, n.field);
		return r.isServerSide ? !0 : s === void 0 || t === s;
	}, [
		n.field,
		r.isServerSide,
		s
	]), f = z((e) => {
		(!e || !e.suppressFocus) && o.current?.focus();
	}, []);
	je({
		doesFilterPass: d,
		afterGuiAttached: f
	});
	let p = (e) => {
		c(e === void 0 ? e : e === "true");
	};
	return B(() => {
		s === void 0 ? e && t(null) : t({
			...e,
			filter: s,
			filterType: "boolean",
			type: "equals"
		});
	}, [s]), /* @__PURE__ */ $("div", {
		className: "ag-filter-wrapper ag-focus-managed filter-containers",
		children: [/* @__PURE__ */ Q("div", {
			className: "ag-filter-body-wrapper ag-simple-filter-body-wrapper",
			children: /* @__PURE__ */ Q(le, {
				ref: o,
				direction: "column",
				className: G(u, "radio-group"),
				children: /* @__PURE__ */ $(Ce, {
					tabIndex: -1,
					name: "option",
					value: s?.toString() || "",
					defaultValue: s?.toString() || "",
					onValueChange: (e) => p(e),
					children: [/* @__PURE__ */ Q(Se, {
						label: l?.true || "True",
						value: "true"
					}), /* @__PURE__ */ Q(Se, {
						label: l?.false || "False",
						value: "false"
					})]
				})
			})
		}), /* @__PURE__ */ Q("div", {
			className: "ag-filter-apply-panel",
			children: /* @__PURE__ */ Q("button", {
				className: "ag-button ag-standard-button ag-filter-apply-panel-button",
				onClick: () => {
					s !== void 0 && c(void 0);
				},
				children: l?.resetFilter || "Reset"
			})
		})]
	});
}, st = () => /* @__PURE__ */ Q(Z, { name: "search" }), ct = ({ model: e, onModelChange: t, options: n = [], context: r, getValue: i, colDef: a, api: o }) => {
	let s = U(null), [c, l] = W(e?.filter || []), [u, d] = W(""), f = o.getGridOption("localeText"), p = q(K.Input), m = q(K.Checkbox), h = n.filter(({ label: e }) => e.toLowerCase().includes(u.toLowerCase())), g = z(({ node: e }) => {
		let t = i(e, a.field);
		return r.isServerSide ? !0 : c.includes(t);
	}, [
		a.field,
		r.isServerSide,
		c
	]), _ = z((e) => {
		(!e || !e.suppressFocus) && s.current?.focus();
	}, []);
	je({
		doesFilterPass: g,
		afterGuiAttached: _
	});
	let v = (e, t) => {
		l((n) => t ? [...n, e] : n.filter((t) => t !== e));
	};
	return B(() => {
		c.length > 0 ? t({
			...e,
			filter: c,
			filterType: "enum",
			type: "in"
		}) : e && t(null);
	}, [c]), /* @__PURE__ */ $("div", {
		className: "ag-filter-wrapper ag-focus-managed filter-containers",
		children: [/* @__PURE__ */ $("div", {
			className: "ag-filter-body-wrapper ag-simple-filter-body-wrapper",
			children: [/* @__PURE__ */ Q(fe, {
				className: G(p, "search-container"),
				children: /* @__PURE__ */ Q(be, {
					prefixIcon: st,
					children: /* @__PURE__ */ Q(X, {
						value: u,
						onChange: (e) => d(e.target.value),
						placeholder: f?.searchOoo || "Search..."
					})
				})
			}), /* @__PURE__ */ Q(le, {
				ref: s,
				className: G(m, "checkbox-group"),
				direction: "column",
				children: /* @__PURE__ */ Q(ye, {
					tabIndex: -1,
					noBorder: !0,
					children: h.map(({ id: e, label: t, value: n }) => /* @__PURE__ */ Q(ce, {
						label: t,
						value: n,
						checked: c.includes(n),
						onCheckedChange: (e) => v(n, !!e)
					}, e))
				})
			})]
		}), /* @__PURE__ */ Q("div", {
			className: "ag-filter-apply-panel",
			children: /* @__PURE__ */ Q("button", {
				className: "ag-button ag-standard-button ag-filter-apply-panel-button",
				onClick: () => {
					c.length !== 0 && l([]);
				},
				children: f?.resetFilter || "Reset"
			})
		})]
	});
}, lt = {
	[i.booleanType]: ot,
	[i.enumType]: ct
}, ut = (e, t) => [...e.sort((e, t) => e.order - t.order).map((e) => {
	let n = {
		headerName: A(e.displayName),
		field: e.keyName,
		sortable: !0,
		suppressMovable: !0,
		flex: 1,
		comparator: () => 0,
		...S(e, t, lt),
		filterValueGetter: ({ context: t, api: n, colDef: r, data: i }) => t.isServerSide ? dt(n.getFilterModel()[r?.field || ""]) : i?.[e.keyName],
		valueGetter: (t) => t.data ? t.data[e.keyName] : void 0,
		cellRenderer: (e) => e.value == null ? "" : e.value
	};
	return e.sort?.active && (n.sort = e.sort.direction === "ASC" ? "asc" : "desc", n.sortingOrder = ["asc", "desc"]), n;
})], dt = (e) => {
	switch (e?.filterType) {
		case "text": return ft(e);
		case "number": return pt(e);
		case "date": return mt(e);
		case "boolean": return !0;
		case "enum": return e.filter;
		default: return "";
	}
}, ft = (e) => {
	switch (e.type) {
		case "notEqual": return "";
		case "notContains": return "";
		default: return e.filter;
	}
}, pt = (e) => {
	switch (e.type) {
		case "lessThan": return e.filter - 1;
		case "greaterThan": return e.filter + 1;
		default: return e.filter;
	}
}, mt = (e) => {
	let t;
	switch (e.type) {
		case "lessThan": return t = new Date(e.dateFrom), t.setDate(t.getDate() - 1), t;
		case "greaterThan": return t = new Date(e.dateFrom), t.setDate(t.getDate() + 1), t;
		default: return e.dateFrom;
	}
}, ht = (e, t) => Object.keys(e).map((n) => {
	let r = t.find((e) => e.keyName === n);
	return r ? {
		keyName: n,
		keyType: r.keyType,
		columnType: r.columnType,
		operator: x(e[n].type),
		value: C(e[n], r)
	} : null;
}).filter(Boolean), gt = (e) => e.map((e) => ({
	...e.columnValues,
	agGridId: e.tokenUuid
})), _t = (e) => new Promise((t) => setTimeout(t, e)), vt = {
	filters: [],
	sort: [],
	keyword: "",
	viewData: void 0,
	pageNumber: 0,
	totalNumberOfRows: 0,
	rebuildRequired: !1,
	pagedTasks: {},
	tasksDetails: {},
	selectedTask: void 0,
	enumerations: {},
	isTasksLoading: !1,
	selectedTasks: []
};
function yt(e, t) {
	switch (t.type) {
		case "SET_FILTERS": return {
			...e,
			filters: t.payload,
			rebuildRequired: !0,
			pagedTasks: {}
		};
		case "SET_SORT": return {
			...e,
			sort: t.payload,
			rebuildRequired: !0,
			pagedTasks: {}
		};
		case "SET_KEYWORD": return {
			...e,
			keyword: t.payload,
			rebuildRequired: !0,
			pagedTasks: {}
		};
		case "SET_PAGE_NUMBER": return {
			...e,
			pageNumber: t.payload
		};
		case "SET_TOTAL_NUMBER_OF_ROWS": return e.totalNumberOfRows === t.payload ? e : {
			...e,
			totalNumberOfRows: t.payload
		};
		case "SET_REBUILD_REQUIRED": return {
			...e,
			rebuildRequired: t.payload,
			pagedTasks: t.payload ? {} : e.pagedTasks
		};
		case "SET_PAGED_TASKS": {
			let n = e.pagedTasks[t.payload.pageNumber];
			return n && Oe(n, t.payload.tasks) ? e : {
				...e,
				pagedTasks: {
					...e.pagedTasks,
					[t.payload.pageNumber]: t.payload.tasks
				}
			};
		}
		case "SET_TASKS_LOADING": return {
			...e,
			isTasksLoading: t.payload
		};
		case "SET_SELECTED_TASKS": return {
			...e,
			selectedTasks: t.payload
		};
		case "SET_TASKS_DETAILS": return {
			...e,
			tasksDetails: {
				...e.tasksDetails,
				...t.payload
			}
		};
		case "SET_SELECTED_TASK": return {
			...e,
			selectedTask: t.payload
		};
		default: return e;
	}
}
var bt = (e) => e.selectedTask ? e.tasksDetails[e.selectedTask.id] : {
	comments: [],
	history: []
}, xt = async (e) => {
	let t = e.currentSwimlane.owner?.username, n = !1;
	if (t) {
		let r = await h(e.id, e.tokenUuid, { keyword: t });
		r.length && e.currentSwimlane?.owner && (n = r[0].enabled);
	}
	return n;
};
function St(e, n, r, i) {
	let [a, l] = oe(yt, {
		...vt,
		viewData: e,
		enumerations: n
	}), u = U(null), d = U(a.selectedTask), p = U(!1), b = z((e) => {
		l({
			type: "SET_FILTERS",
			payload: e
		});
	}, []), x = z((e) => {
		l({
			type: "SET_SORT",
			payload: e
		});
	}, []), S = z(De((e) => {
		l({
			type: "SET_KEYWORD",
			payload: e
		}), i?.searched(e), a.pageNumber !== 0 && l({
			type: "SET_PAGE_NUMBER",
			payload: 0
		});
	}, 600), [a.pageNumber]), C = z((e) => {
		l({
			type: "SET_PAGE_NUMBER",
			payload: e
		});
	}, []), w = z((e) => {
		l({
			type: "SET_SELECTED_TASKS",
			payload: e
		});
	}, []), T = z(async () => {
		if (a.pagedTasks[a.pageNumber] === void 0 || a.rebuildRequired) {
			let t = p.current;
			p.current = !1, t || l({
				type: "SET_TASKS_LOADING",
				payload: !0
			});
			let n = await y(a.sort, a.filters, a.keyword, e, {
				page: a.pageNumber,
				size: r
			}, a.enumerations), o = a.pageNumber, { content: s, totalElements: c } = n;
			l({
				type: "SET_PAGED_TASKS",
				payload: {
					pageNumber: o,
					tasks: s
				}
			}), l({
				type: "SET_TOTAL_NUMBER_OF_ROWS",
				payload: c
			}), l({
				type: "SET_REBUILD_REQUIRED",
				payload: !1
			}), i?.loaded(c), t || l({
				type: "SET_TASKS_LOADING",
				payload: !1
			});
		}
	}, [
		a.pagedTasks,
		a.pageNumber,
		a.rebuildRequired,
		a.sort,
		a.filters,
		a.keyword,
		a.enumerations,
		e,
		r,
		i
	]), E = z(async (e, t = !1) => {
		if (a.tasksDetails[e] === void 0 || t) {
			let t = await g(e), n = await _(e);
			l({
				type: "SET_TASKS_DETAILS",
				payload: { [e]: {
					comments: t,
					history: n
				} }
			});
		}
	}, [a.tasksDetails]), ee = z(async (e) => {
		let { pageNumber: t, pagedTasks: n } = a;
		if (t === void 0 || e === -1) {
			l({
				type: "SET_SELECTED_TASK",
				payload: void 0
			});
			return;
		}
		let i = n[t]?.[e - t * r];
		i?.currentSwimlane?.owner?.username && (i.currentSwimlane.owner.enabled = await xt(i)), l({
			type: "SET_SELECTED_TASK",
			payload: i
		}), E(i.id);
	}, [a, r]), D = z(async (e, n) => {
		let { selectedTasks: r } = a;
		if (r.length === 0) return;
		let o = r.map(({ id: e, tokenUuid: t }) => ({
			id: e,
			tokenUuid: t
		}));
		w([]), P(), await re(o, e, n), i?.taskActioned(e, r.map((e) => e.processInstance?.processState), o.length), await _t(t), l({
			type: "SET_REBUILD_REQUIRED",
			payload: !0
		}), F();
	}, [a.selectedTasks, i]), k = z(async (e) => m(a.selectedTasks, { keyword: e }), [a.selectedTasks]), A = z(async (e, t) => {
		try {
			let n = await N(e, { message: t }), r = bt(a);
			return l({
				type: "SET_TASKS_DETAILS",
				payload: {
					...a.tasksDetails,
					[e]: {
						...r,
						comments: [n, ...r.comments]
					}
				}
			}), n;
		} catch (e) {
			console.error("Error saving comment:", e);
			return;
		}
	}, [a]), j = z(async (e, t) => {
		try {
			await te(e, t);
			let n = bt(a);
			l({
				type: "SET_TASKS_DETAILS",
				payload: {
					...a.tasksDetails,
					[e]: {
						...n,
						comments: n.comments.filter((e) => e.commentId !== t)
					}
				}
			});
		} catch (e) {
			console.error("Error deleting comment:", e);
		}
	}, [a]), M = z(async (e, t) => {
		switch (e.type) {
			case o.Open:
				console.log("SSE connection open");
				break;
			case o.Error:
				console.error("SSE connection error", e);
				break;
			case o.Data: if (t?.eventType === c.VIEW_UPDATED) switch (t?.taskEventType) {
				case s.TASK_UPDATED:
				case s.TASK_CREATED:
					if (d.current && d.current.id === t.taskId) {
						let e = await v(d.current.id, d.current.tokenUuid);
						e.currentSwimlane?.owner?.username && (e.currentSwimlane.owner.enabled = await xt(e)), l({
							type: "SET_SELECTED_TASK",
							payload: {
								...d.current,
								...e
							}
						}), E(e.id, !0);
					}
					p.current = !0, l({
						type: "SET_REBUILD_REQUIRED",
						payload: !0
					});
			}
		}
	}, []), P = z(() => {
		try {
			u.current?.close();
		} catch (e) {
			if (e?.name !== "AbortError") throw e;
		}
	}, []), F = z(() => {
		let e = a.viewData?.resourceId;
		e && (P(), u.current = O(e, M));
	}, [
		a.viewData?.resourceId,
		M,
		P
	]);
	B(() => (F(), () => {
		P();
	}), [F, P]), B(() => {
		let e = () => {
			document.visibilityState === "hidden" ? P() : document.visibilityState === "visible" && (F(), p.current = !0, l({
				type: "SET_REBUILD_REQUIRED",
				payload: !0
			}));
		};
		return document.addEventListener("visibilitychange", e), () => document.removeEventListener("visibilitychange", e);
	}, [F, P]), B(() => {
		a.pageNumber !== void 0 && T();
	}, [T, a.pageNumber]), B(() => {
		l({
			type: "SET_REBUILD_REQUIRED",
			payload: !0
		}), a.pageNumber !== 0 && l({
			type: "SET_PAGE_NUMBER",
			payload: 0
		});
	}, [r]), B(() => {
		d.current?.id !== a.selectedTask?.id && (d.current = a.selectedTask);
	}, [a.selectedTask]);
	let ne = z(async (e, t) => e === void 0 ? [] : h(e.id, e.tokenUuid, { keyword: t }), []), I = z(async (e, t) => {
		t !== void 0 && (await R(t.id, e), i?.priorityChanged(e));
	}, [i]), L = z((e) => {
		let t = e.selectedTask;
		if (t) return {
			task: t,
			details: bt(e),
			onActionUpdate: async (e, n) => {
				await ie(e, t.id, t.tokenUuid, n), i?.taskActioned(e, t.processInstance?.processState);
			},
			onViewApplication: () => i?.taskActioned(f.VIEW, t.processInstance?.processState),
			onCommentCreate: (e) => A(t.id, e),
			onCommentDelete: (e) => j(t.id, e),
			onPriorityUpdate: (e) => I(e, t),
			searchAssignees: (e) => ne(t, e)
		};
	}, [
		A,
		j,
		I,
		ne,
		i
	]), ae = H(() => L(a), [L, a]);
	return {
		...a,
		setFilters: b,
		setSort: x,
		onKeywordChange: S,
		onPageNumberChange: C,
		onSelectedTaskChanged: ee,
		selectedTaskWithDetails: ae,
		setSelectedTasks: w,
		onBulkTaskActionUpdate: D,
		searchBulkAssignees: k
	};
}
//#endregion
//#region libs/sdk/react/src/components/sdk/task-manager/task-detail/task-priority/FlxTaskPriority.tsx
var Ct = ({ priority: e = null, onPriorityUpdate: t, canEditPriority: n }) => {
	let [r, i] = W(!1), [a, o] = W(e), s = q(K.Button), c = q(K.Input), l = J({
		styles: {},
		component: K.Button
	}), u = J({
		styles: {},
		component: K.Button
	}), d = J({
		styles: {},
		component: K.Button
	}), f = () => i(!0), p = () => {
		i(!1), a !== e && t?.(a);
	}, m = () => {
		i(!1), o(e);
	}, h = (e) => {
		let t = e.target.value, n = Ae(t, 10);
		o(isNaN(n) ? null : n);
	}, g = (e) => {
		"key" in e && (e.key === "-" || e.key === "Minus") && e.preventDefault(), "clipboardData" in e && e.clipboardData.getData("text").trim().startsWith("-") && e.preventDefault();
	};
	return B(() => {
		let t = e?.toString().replace(/^-+/, "");
		t !== a?.toString() && r && o(t ? Ae(t, 10) : null);
	}, [r]), /* @__PURE__ */ $("div", {
		className: "priority-container",
		children: [/* @__PURE__ */ Q("div", {
			className: "info-title",
			children: k("@@sys_tm_priority")
		}), /* @__PURE__ */ Q("div", {
			className: "info-row",
			children: r ? /* @__PURE__ */ $(Ee, { children: [
				/* @__PURE__ */ Q(fe, {
					className: G(c, "priority-input"),
					children: /* @__PURE__ */ Q(be, { children: /* @__PURE__ */ Q(X, {
						value: a ?? "",
						onChange: h,
						type: "number",
						onKeyDown: g,
						onPaste: g
					}) })
				}),
				/* @__PURE__ */ Q(ve, {
					variant: "fill",
					onClick: p,
					className: G(s, ...l, "priority-button", "check-button"),
					"data-uniqueid": "check-button",
					children: /* @__PURE__ */ Q(Z, {
						name: "check",
						className: "check-icon"
					})
				}),
				/* @__PURE__ */ Q(ve, {
					onClick: m,
					className: G(s, ...u, "dismiss-button priority-button"),
					variant: "fill",
					"data-uniqueid": "dismiss-button",
					children: /* @__PURE__ */ Q(Z, {
						name: "close",
						className: "dismiss-icon"
					})
				})
			] }) : /* @__PURE__ */ $(Ee, { children: [/* @__PURE__ */ Q("div", {
				className: "priority-value",
				children: a ?? "-"
			}), n ? /* @__PURE__ */ Q(ve, {
				variant: "ghost",
				"data-uniqueid": "edit-button",
				disabled: !n,
				onClick: f,
				className: G(s, ...d, "edit-button"),
				children: /* @__PURE__ */ Q(Z, {
					name: "edit",
					className: "edit-icon"
				})
			}) : null] })
		})]
	});
}, wt = ({ history: e = [] }) => /* @__PURE__ */ $("div", {
	className: "flx-history-section",
	children: [/* @__PURE__ */ Q("h6", {
		className: "title",
		children: k("@@sys_tm_history")
	}), /* @__PURE__ */ Q("ul", {
		className: "history-list",
		children: e?.map(({ date: e, historyId: t, events: n }) => /* @__PURE__ */ Q(ae, { children: n.map((t, n) => /* @__PURE__ */ $("li", {
			className: "history-entry",
			children: [/* @__PURE__ */ Q("div", {
				className: "history-log-date",
				children: w(e, p().language)
			}), /* @__PURE__ */ Q("div", {
				className: "history-log-message",
				dangerouslySetInnerHTML: { __html: b(t) }
			}, n)]
		}, n)) }, t))
	})]
}), Tt = ({ comments: e = [], onCommentCreate: t, onCommentDelete: n }) => {
	let [r, i] = W(""), a = U(""), o = q(K.Input), s = q(K.Button), c = (e) => {
		a.current = e.target.value, i(e.target.value);
	}, l = z(async () => {
		a.current && await t(a.current) && (a.current = "", i(""));
	}, [t]), u = async (e) => {
		n(e);
	}, d = !r, f = H(() => function() {
		return /* @__PURE__ */ Q(ue, {
			name: "send",
			onClick: d ? void 0 : l,
			className: G("comment-send", { disabled: d })
		});
	}, [d, l]);
	return /* @__PURE__ */ $("div", {
		className: "flx-comments-section",
		children: [
			/* @__PURE__ */ Q("h6", {
				className: "title",
				children: k("@@sys_tm_comments")
			}),
			/* @__PURE__ */ Q(fe, {
				className: G(o, "comment-input"),
				children: /* @__PURE__ */ Q(de, {
					filled: !!r,
					suffixIcon: f,
					children: /* @__PURE__ */ Q(X, {
						value: r,
						onChange: c,
						onKeyDown: (e) => e.key === "Enter" && l(),
						placeholder: k("@@sys_tm_write_a_comment")
					})
				})
			}),
			/* @__PURE__ */ Q("ul", {
				className: "comments-list",
				children: e?.map(({ commentId: e, author: t, message: n, createdDate: r }) => /* @__PURE__ */ $("li", { children: [/* @__PURE__ */ $("div", {
					className: "comment-info",
					children: [/* @__PURE__ */ $("div", {
						className: "comment-author",
						children: [/* @__PURE__ */ $("div", {
							className: "avatar",
							children: [t.firstName.charAt(0).toUpperCase(), t.lastName.charAt(0).toUpperCase()]
						}), /* @__PURE__ */ $("span", { children: [
							t.firstName,
							" ",
							t.lastName
						] })]
					}), /* @__PURE__ */ $("div", {
						className: "comment-actions",
						children: [/* @__PURE__ */ Q(Y, {
							variant: "text",
							className: G(s),
							onClick: () => u(e),
							children: /* @__PURE__ */ Q(ue, { name: "trash" })
						}), /* @__PURE__ */ Q("span", {
							className: "comment-date",
							children: w(r, p().language)
						})]
					})]
				}), /* @__PURE__ */ Q("div", {
					className: "comment-message",
					children: n
				})] }, e))
			})
		]
	});
}, Et = ({ task: t, details: r, searchAssignees: i, onCommentCreate: o, onCommentDelete: s, onActionUpdate: c, onPriorityUpdate: u, onViewApplication: p }) => {
	let { currentSwimlane: m, processInstance: h, modifiedDate: g, stage: _, priority: v, title: y, baseUrl: b, possibleActions: x = [], appId: S } = t || {}, C = e(), [w, E] = W(m?.owner?.username || ""), [D, O] = W(m?.owner ? L([m?.owner]).map((e) => ({
		...e,
		enabled: !0
	})) : []), [A, te] = W(""), [j, M] = W(!1), N = U(!1), P = U(w);
	P.current = w;
	let F = U(D);
	F.current = D;
	let ne = g ? T(n)?.format(new Date(g)) : "-", I = q(K.Button), re = q(K.Select), ie = q(K.SelectOption), R = a[h.processState], ae = H(() => j ? k("@@sys_tm_loading") : A.length < 4 ? k("@@sys_tm_search_term_validation") : k("@@sys_tm_nothing_found"), [j, A]), V = z(() => {
		let e = h?.contextInstanceUuid || h?.processInstanceUuid;
		b && e && S && (p?.(), window.open(ee(b, S, e), "_blank"));
	}, [
		b,
		S,
		h?.contextInstanceUuid,
		h?.processInstanceUuid,
		p
	]), oe = De(async (e) => {
		M(!0);
		try {
			if (N.current) N.current = !1;
			else {
				let t = await i(e);
				O(L(t).map((e) => ({
					...e,
					enabled: !0
				})));
			}
		} catch (e) {
			O([]), N.current = !1, console.error("Error while searching users", e);
		} finally {
			M(!1);
		}
	}, 600), J = z(async (e) => {
		if (te(e), !(P.current && e === F.current.find((e) => e.value === P.current)?.label)) {
			if (!e.trim() || e.length < 4) {
				oe.cancel(), P.current || O([]);
				return;
			}
			await oe(e);
		}
	}, []), se = (e) => {
		let t = e;
		N.current = !0, c(f.ASSIGN, t.value), E(t.value);
	};
	B(() => {
		E(m?.owner?.username || ""), O(m?.owner?.username ? L([m?.owner]).map((e) => ({
			...e,
			enabled: !0
		})) : []);
	}, [m]);
	let ce = f.HOLD, le = f.UNHOLD, ue = f.ASSIGN, de = f.UNASSIGN, fe = f.SELF_ASSIGN, X = H(() => l.reduce((e, t) => ({
		...e,
		[t.id]: k(t.label)
	}), {}), []);
	return /* @__PURE__ */ $("div", {
		className: "flx-task-container",
		children: [
			/* @__PURE__ */ $("div", {
				className: "flx-task-header",
				children: [/* @__PURE__ */ Q("h5", { children: y || k("@@sys_tm_title") }), /* @__PURE__ */ $("div", {
					className: "flx-status-container",
					children: [/* @__PURE__ */ Q("span", {
						className: "flx-status-badge",
						style: { backgroundColor: R },
						children: X[h?.processState]
					}), [ce, le].map((e) => x.includes(e) ? /* @__PURE__ */ Q(Y, {
						variant: "text",
						onClick: () => c(e),
						className: G(I, "flx-button-assign"),
						children: k(d[e])
					}, e) : null)]
				})]
			}),
			/* @__PURE__ */ $("div", {
				className: "task-details",
				children: [
					/* @__PURE__ */ Q(Ct, {
						canEditPriority: x.includes(f.CHANGE_PRIORITY),
						priority: v,
						onPriorityUpdate: u
					}),
					/* @__PURE__ */ $("div", {
						className: "detail-item",
						children: [/* @__PURE__ */ Q("strong", { children: k("@@sys_tm_stage") }), /* @__PURE__ */ $("span", { children: [_, "\xA0"] })]
					}),
					/* @__PURE__ */ $("div", {
						className: "detail-item",
						children: [/* @__PURE__ */ Q("strong", { children: k("@@sys_tm_last_updated") }), /* @__PURE__ */ Q("span", { children: ne })]
					}),
					/* @__PURE__ */ Q(Y, {
						variant: "fill",
						disabled: !b,
						onClick: V,
						className: G(I),
						children: k(d[f.VIEW])
					})
				]
			}),
			/* @__PURE__ */ $("div", {
				className: "flx-assignee-section",
				children: [/* @__PURE__ */ Q(he, {
					className: G(re, "flx-select-assignee"),
					children: /* @__PURE__ */ Q(me, {
						hasSearch: !0,
						hasClear: !0,
						useServerFiltering: !0,
						options: D,
						onSearch: J,
						disabled: !x.includes(ue),
						onChange: se,
						clearFn: () => {
							E(""), O([]);
						},
						value: D.find((e) => e.value === w) || null,
						emptyMessage: ae,
						placeholder: k("@@sys_tm_select_person"),
						optionClassName: G(ie),
						container: C,
						children: (e, t) => /* @__PURE__ */ Q(we, {
							label: e.label,
							className: G(ie),
							onClick: t
						}, e.value)
					})
				}), [de, fe].map((e) => /* @__PURE__ */ Q(Y, {
					variant: "ghost",
					onClick: () => {
						c(e);
					},
					className: G(I, "flx-button-assign"),
					disabled: !x.includes(e),
					children: k(d[e])
				}, e))]
			}),
			/* @__PURE__ */ $("div", {
				className: "task-grid",
				children: [/* @__PURE__ */ Q(Tt, {
					comments: r?.comments,
					onCommentCreate: o,
					onCommentDelete: s
				}), /* @__PURE__ */ Q(wt, { history: r?.history })]
			})
		]
	});
}, Dt = () => /* @__PURE__ */ Q(Z, { name: "search" }), Ot = ({ tasks: e, onUpdateTasks: t, searchUsers: n }) => {
	let [r, i] = W(""), [a, o] = W([]), [s, c] = W(!1), [l, u] = W(!1), [d, p] = W(!1), m = U({
		top: 0,
		left: 0
	}), h = H(() => k(l ? "@@sys_tm_loading" : d ? "@@sys_tm_nothing_found" : "@@sys_tm_search_term_validation"), [l, d]), g = q(K.Button), _ = q(K.Card), v = q(K.Input), y = q(K.SelectOption), b = H(() => E(e), [e]), x = z(De(async (e) => {
		u(!0);
		try {
			let t = await n(e);
			o(L(t)), p(!0);
		} catch (e) {
			o([]), console.error("Error while searching users", e);
		} finally {
			u(!1);
		}
	}, 600), [n]), S = (e) => {
		let t = e.currentTarget, n = t.getBoundingClientRect(), r = t.closest(".flx-task-management-container")?.getBoundingClientRect() ?? {
			top: 0,
			left: 0
		};
		m.current = {
			top: n.bottom - r.top,
			left: n.left - r.left
		}, c(!0);
	}, C = () => {
		c(!1), i(""), o([]);
	}, w = (e) => {
		t(f.ASSIGN, e), C();
	}, T = (e, n) => {
		if (n === f.ASSIGN) {
			S(e);
			return;
		}
		t(n);
	};
	return B(() => {
		if (r.length < 4) {
			p(!1), o([]);
			return;
		}
		x(r);
	}, [r, n]), /* @__PURE__ */ Q("div", {
		className: "flx-bulk-tasks",
		children: /* @__PURE__ */ $("div", {
			className: G("flx-task-actions", { empty: b.length === 0 }),
			children: [b.map(({ value: e, label: t }) => /* @__PURE__ */ Q(Y, {
				variant: "ghost",
				className: G(g),
				onClick: (t) => T(t, e),
				children: t
			}, e)), s && /* @__PURE__ */ $(Ee, { children: [/* @__PURE__ */ Q("div", {
				className: "flx-assign-users-search-backdrop",
				onClick: () => C()
			}), /* @__PURE__ */ $(se, {
				className: G(_, "flx-assign-users-search"),
				style: {
					top: `${m.current.top}px`,
					left: `${m.current.left}px`
				},
				children: [
					/* @__PURE__ */ Q(xe, {
						className: G(v),
						children: /* @__PURE__ */ Q(be, {
							prefixIcon: Dt,
							children: /* @__PURE__ */ Q(X, {
								value: r,
								onChange: (e) => i(e.target.value),
								placeholder: k("@@sys_tm_search_person")
							})
						})
					}),
					a.length === 0 && /* @__PURE__ */ Q(ge, {
						className: G(y, "flx-select-option-empty"),
						label: h
					}),
					a.map(({ value: e, label: t }) => /* @__PURE__ */ Q(ge, {
						className: G(y),
						label: t,
						onClick: () => w(e)
					}, e))
				]
			})] })]
		})
	});
}, kt = {
	ar: Le,
	bg: Me,
	cs: Pe,
	da: Ie,
	de: Fe,
	el: Ve,
	es: Re,
	fa: Ge,
	fi: ze,
	fr: Be,
	he: We,
	hr: He,
	hu: Ue,
	it: Ke,
	ja: qe,
	ko: Je,
	nb: Xe,
	nl: Ye,
	pl: Qe,
	pt: $e,
	ro: {
		selectAll: "(Selectează tot)",
		selectAllSearchResults: "(Selectează toate rezultatele căutării)",
		addCurrentSelectionToFilter: "Adaugă selecția curentă la filtru",
		searchOoo: "Căutare...",
		blanks: "(Goluri)",
		noMatches: "Fără potriviri",
		typeToSearchOoo: "Tastează pentru a căuta...",
		filterOoo: "Filtrează...",
		equals: "Egal",
		notEqual: "Nu este egal",
		blank: "Gol",
		notBlank: "Nu este gol",
		empty: "Alege una",
		lessThan: "Mai puțin decât",
		greaterThan: "Mai mult decât",
		lessThanOrEqual: "Mai puțin sau egal cu",
		greaterThanOrEqual: "Mai mult sau egal cu",
		inRange: "Între",
		inRangeStart: "De la",
		inRangeEnd: "Până la",
		contains: "Conține",
		notContains: "Nu conține",
		startsWith: "Începe cu",
		endsWith: "Se termină cu",
		dateFormatOoo: "yyyy-mm-dd",
		before: "Înainte",
		after: "După",
		yesterday: "Ieri",
		today: "Astăzi",
		tomorrow: "Mâine",
		last7Days: "Ultimele 7 zile",
		lastWeek: "Săptămâna trecută",
		thisWeek: "Această săptămână",
		nextWeek: "Săptămâna viitoare",
		last30Days: "Ultimele 30 de zile",
		lastMonth: "Luna trecută",
		thisMonth: "Această lună",
		nextMonth: "Luna viitoare",
		last90Days: "Ultimele 90 de zile",
		lastQuarter: "Trimestrul trecut",
		thisQuarter: "Acest trimestru",
		nextQuarter: "Trimestrul viitor",
		lastYear: "Anul trecut",
		thisYear: "Acest an",
		yearToDate: "De la începutul anului până în prezent",
		nextYear: "Anul viitor",
		last6Months: "Ultimele 6 luni",
		last12Months: "Ultimele 12 luni",
		last24Months: "Ultimele 24 de luni",
		andCondition: "ȘI",
		orCondition: "SAU",
		applyFilter: "Aplică",
		applyColumnToolPanel: "Aplică",
		resetFilter: "Resetează",
		clearFilter: "Curăță",
		cancelFilter: "Anulează",
		cancelColumnToolPanel: "Anulează",
		textFilter: "Filtru text",
		numberFilter: "Filtru număr",
		dateFilter: "Filtru dată",
		setFilter: "Filtru set",
		groupFilterSelect: "Selectează câmp:",
		filterSummaryInactive: "este (Toate)",
		filterSummaryContains: "conține",
		filterSummaryNotContains: "nu conține",
		filterSummaryTextEquals: "este egal cu",
		filterSummaryTextNotEqual: "nu este egal cu",
		filterSummaryStartsWith: "începe cu",
		filterSummaryEndsWith: "se termină cu",
		filterSummaryBlank: "este gol",
		filterSummaryNotBlank: "nu este gol",
		filterSummaryEquals: "=",
		filterSummaryNotEqual: "!=",
		filterSummaryGreaterThan: ">",
		filterSummaryGreaterThanOrEqual: ">=",
		filterSummaryLessThan: "<",
		filterSummaryLessThanOrEqual: "<=",
		filterSummaryInRange: "între",
		filterSummaryInRangeValues: "(${variable}, ${variable})",
		filterSummaryTextQuote: "\"${variable}\"",
		filterSummaryListInactive: "este (Toate)",
		filterSummaryListSeparator: ", ",
		filterSummaryListShort: "este (${variable})",
		filterSummaryListLong: "este (${variable}) și ${variable} mai mult",
		addFilterCard: "Adaugă filtru",
		agTextColumnFilterDisplayName: "Filtru simplu",
		agNumberColumnFilterDisplayName: "Filtru simplu",
		agDateColumnFilterDisplayName: "Filtru simplu",
		agSetColumnFilterDisplayName: "Filtru de selecție",
		agMultiColumnFilterDisplayName: "Filtru combinat",
		addFilterPlaceholder: "Caută coloane...",
		advancedFilterContains: "conține",
		advancedFilterNotContains: "nu conține",
		advancedFilterTextEquals: "egal",
		advancedFilterTextNotEqual: "nu este egal",
		advancedFilterStartsWith: "începe cu",
		advancedFilterEndsWith: "se termină cu",
		advancedFilterBlank: "este gol",
		advancedFilterNotBlank: "nu este gol",
		advancedFilterEquals: "=",
		advancedFilterNotEqual: "!=",
		advancedFilterGreaterThan: ">",
		advancedFilterGreaterThanOrEqual: ">=",
		advancedFilterLessThan: "<",
		advancedFilterLessThanOrEqual: "<=",
		advancedFilterTrue: "este adevărat",
		advancedFilterFalse: "este fals",
		advancedFilterAnd: "ȘI",
		advancedFilterOr: "SAU",
		advancedFilterApply: "Aplică",
		advancedFilterReset: "Resetare",
		advancedFilterCancel: "Anulează",
		advancedFilterClear: "Șterge",
		advancedFilterBuilder: "Constructor",
		advancedFilterValidationMissingColumn: "Lipsă coloană",
		advancedFilterValidationMissingOption: "Lipsă opțiune",
		advancedFilterValidationMissingValue: "Lipsă valoare",
		advancedFilterValidationInvalidColumn: "Coloană negăsită",
		advancedFilterValidationInvalidOption: "Opțiune negăsită",
		advancedFilterValidationMissingQuote: "Valorii îi lipsesc ghilimelele de încheiere",
		advancedFilterValidationNotANumber: "Valoarea nu este un număr",
		advancedFilterValidationInvalidDate: "Valoarea nu este o dată validă",
		advancedFilterValidationMissingCondition: "Lipsă condiție",
		advancedFilterValidationJoinOperatorMismatch: "Operatorii de unire din cadrul unei condiții trebuie să fie aceiași",
		advancedFilterValidationInvalidJoinOperator: "Operator de unire negăsit",
		advancedFilterValidationMissingEndBracket: "Lipsă paranteză de încheiere",
		advancedFilterValidationExtraEndBracket: "Prea multe paranteze de încheiere",
		advancedFilterValidationMessage: "Expresia are o eroare. ${variable} - ${variable}.",
		advancedFilterValidationMessageAtEnd: "Expresia are o eroare. ${variable} la sfârșitul expresiei.",
		advancedFilterBuilderTitle: "Filtru Avansat",
		advancedFilterBuilderApply: "Aplică",
		advancedFilterBuilderClear: "Șterge",
		advancedFilterBuilderReset: "Resetare",
		advancedFilterBuilderCancel: "Anulează",
		advancedFilterBuilderAddButtonTooltip: "Adaugă Filtru sau Grup",
		advancedFilterBuilderRemoveButtonTooltip: "Elimină",
		advancedFilterBuilderMoveUpButtonTooltip: "Mută În Sus",
		advancedFilterBuilderMoveDownButtonTooltip: "Mută În Jos",
		advancedFilterBuilderAddJoin: "Adaugă Grup",
		advancedFilterBuilderAddCondition: "Adaugă Filtru",
		advancedFilterBuilderSelectColumn: "Selectează o coloană",
		advancedFilterBuilderSelectOption: "Selectează o opțiune",
		advancedFilterBuilderEnterValue: "Introdu o valoare...",
		advancedFilterBuilderValidationAlreadyApplied: "Filtrul curent a fost deja aplicat.",
		advancedFilterBuilderValidationIncomplete: "Nu toate condițiile sunt complete.",
		advancedFilterBuilderValidationSelectColumn: "Trebuie să selectați o coloană.",
		advancedFilterBuilderValidationSelectOption: "Trebuie să selectați o opțiune.",
		advancedFilterBuilderValidationEnterValue: "Trebuie să introduceți o valoare.",
		minDateValidation: "Data trebuie să fie după ${variable}",
		maxDateValidation: "Data trebuie să fie înainte de ${variable}",
		maxLengthValidation: "Trebuie să fie cel mult ${variable} caractere.",
		minValueValidation: "Trebuie să fie mai mare sau egal cu ${variable}",
		maxValueValidation: "Trebuie să fie mai mic sau egal cu ${variable}",
		strictMinValueValidation: "Trebuie să fie mai mare decât ${variable}",
		strictMaxValueValidation: "Trebuie să fie mai mic decât ${variable}",
		invalidSelectionValidation: "Selecție invalidă.",
		invalidFormulaValidation: "Formulă invalidă.",
		formulaParseInvalidCellReference: "Referință de celulă invalidă: ${variable}.",
		formulaParseInvalidRangeEndReference: "Referință de sfârșit de interval invalidă.",
		formulaParseUnterminatedString: "Șir neterminat.",
		formulaParseUnexpectedCharacter: "Caracter neașteptat: ${variable}.",
		formulaParseOperatorStackUnderflow: "Subdepășire a stivei de operatori.",
		formulaParseMissingOperand: "Operand lipsă pentru '${variable}'.",
		formulaParseInternalUnexpectedFrameDuringReduction: "Eroare internă: cadru neașteptat în timpul reducerii.",
		formulaParseInternalUnexpectedFrameBeforeOpenParen: "Eroare internă: cadru neașteptat înainte de '('.",
		formulaParseMisplacedComma: "Virgulă plasată greșit.",
		formulaParseCommaOutsideFunctionCall: "Virgulă în afara unui apel de funcție.",
		formulaParseInternalUnexpectedFrameBeforeCloseParen: "Eroare internă: cadru neașteptat înainte de ')'.",
		formulaParseMismatchedParentheses: "Paranteze necorespunzătoare.",
		formulaParseUnsupportedOperand: "Operand neacceptat: ${variable}.",
		formulaParseMismatchedParenthesesOrUnfinishedFunctionCall: "Paranteze necorespunzătoare sau apel de funcție neterminat.",
		formulaParseInvalidExpression: "Expresie invalidă.",
		formulaParseFormulasMustBeginWithEquals: "Formulele trebuie să înceapă cu =.",
		formulaSerializeStringContainsQuote: "Șirul conține ghilimele (\") pe care tokenizatorul nu le acceptă.",
		formulaSerializeCannotProduceAbsoluteColumnLabelFromId: "Nu se poate produce eticheta absolută de COLOANĂ din id-ul '${variable}'.",
		formulaSerializeCannotProduceAbsoluteRowIndexFromId: "Nu se poate produce indexul absolut de RÂND din id-ul '${variable}'.",
		formulaSerializeCannotProduceRowIndexFromId: "Nu se poate produce indexul de RÂND din id-ul '${variable}'.",
		formulaSerializeCannotMapColumnIdToA1Label: "Nu se poate mapa id-ul coloanei '${variable}' la eticheta A1.",
		formulaSerializeCannotParseAbsoluteRowIndex: "Nu se poate analiza indexul absolut de rând '${variable}'.",
		formulaSerializeCannotMapRowIdToA1Index: "Nu se poate mapa id-ul rândului '${variable}' la indexul A1.",
		formulaEvalRangeNotAllowedInScalarContext: "Intervalul nu este permis în context scalar.",
		formulaEvalUnknownReferenceToCell: "Referință necunoscută la celulă.",
		formulaEvalUnsupportedOperation: "Operație neacceptată ${variable}.",
		formulaEvalInvalidAbsoluteRow: "Rând absolut invalid.",
		formulaEvalUnrecognisedRowId: "Id de rând nerecunoscut.",
		formulaEvalInvalidAbsoluteColumn: "Coloană absolută invalidă.",
		formulaEvalUnrecognisedColumnId: "Id de coloană nerecunoscut.",
		formulaEvalUnrecognisedRowInRange: "Rând nerecunoscut în interval.",
		formulaEvalUnrecognisedReferenceToCell: "Referință la celulă nerecunoscută.",
		formulaEvalIncompleteRangeReference: "Referință de interval incompletă.",
		formulaFunctionExpectedExactlyArguments: "${variable}: se așteptau exact ${variable} argumente.",
		formulaFunctionExpectedAtMostArguments: "${variable}: se așteptau cel mult ${variable} argumente.",
		formulaFunctionExpectedAtLeastArguments: "${variable}: se așteptau cel puțin ${variable} argumente.",
		formulaFunctionInvalidCriteriaWildcardsWithComparator: "Criteriu invalid: metacaractere cu operator de comparare.",
		formulaFunctionNonNumericArgument: "${variable}: argument nenumeric.",
		formulaFunctionDivisionByZero: "${variable}: împărțire la zero.",
		formulaFunctionCannotCombineDatesWithBigInt: "${variable}: nu se pot combina datele cu BigInt.",
		formulaFunctionRequiresAtLeastOneNumericValue: "${variable}: necesită cel puțin o valoare numerică.",
		formulaFunctionRequiresAtLeastOneValue: "${variable}: necesită cel puțin o valoare.",
		formulaFunctionAllValuesMustBeNumbers: "${variable}: toate valorile trebuie să fie numere.",
		formulaFunctionArgumentMustBeRange: "${variable}: argumentul ${variable} trebuie să fie un interval.",
		formulaFunctionArgumentMustBeValue: "${variable}: argumentul ${variable} trebuie să fie o valoare.",
		formulaFunctionRangesHaveDifferentSizes: "${variable}: intervalele au dimensiuni diferite.",
		formulaFunctionValuesMustBeNumeric: "${variable}: valorile trebuie să fie numerice.",
		formulaFunctionValuesMustBeIntegers: "${variable}: valorile trebuie să fie numere întregi.",
		formulaFunctionUnsupportedValueType: "${variable}: tip de valoare neacceptat.",
		formulaFunctionDivNonNumericArgument: "DIV: argument nenumeric.",
		formulaFunctionDivDivisionByZero: "DIV: împărțire la zero.",
		formulaFunctionSumCannotCombineDatesWithBigInt: "SUM: nu se pot combina datele cu BigInt.",
		formulaFunctionSumRequiresAtLeastOneNumericValue: "SUM: necesită cel puțin o valoare numerică.",
		formulaFunctionAvgRequiresAtLeastOneValue: "AVG: necesită cel puțin o valoare.",
		formulaFunctionMedianAllValuesMustBeNumbers: "MEDIAN: toate valorile trebuie să fie numere.",
		formulaFunctionMedianRequiresAtLeastOneValue: "MEDIAN: necesită cel puțin o valoare.",
		formulaFunctionSumifFirstArgumentMustBeRange: "SUMIF: primul argument trebuie să fie un interval.",
		formulaFunctionSumifSecondArgumentMustBeValue: "SUMIF: al doilea argument trebuie să fie o valoare (criteriu).",
		formulaFunctionSumifThirdArgumentMustBeRange: "SUMIF: al treilea argument trebuie să fie un interval (sum_range).",
		formulaFunctionSumifRangesHaveDifferentSizes: "SUMIF: intervalele au dimensiuni diferite.",
		formulaFunctionCountifFirstArgumentMustBeRange: "COUNTIF: primul argument trebuie să fie un interval.",
		formulaFunctionCountifSecondArgumentMustBeValue: "COUNTIF: al doilea argument trebuie să fie o valoare (criteriu).",
		formulaFunctionConcatUnsupportedValueType: "CONCAT: tip de valoare neacceptat.",
		formulaFunctionMinRequiresAtLeastOneValue: "MIN: necesită cel puțin o valoare.",
		formulaFunctionMaxRequiresAtLeastOneValue: "MAX: necesită cel puțin o valoare.",
		formulaFunctionPercentNonNumericArgument: "PERCENT: argument nenumeric.",
		formulaFunctionPowerNonNumericArgument: "POWER: argument nenumeric.",
		formulaServiceCircularReference: "Referință circulară.",
		formulaServiceExpectedParsableFormula: "Se aștepta o formulă care poate fi analizată.",
		formulaServiceInternalSchedulingError: "Eroare internă de planificare.",
		tooltipValidationErrorSeparator: ". ",
		columns: "Coloane",
		filters: "Filtre",
		pivotMode: "Mod Pivot",
		groups: "Grupuri de Rânduri",
		rowGroupColumnsEmptyMessage: "Trageți aici pentru a seta grupuri de rânduri",
		values: "Valori",
		valueColumnsEmptyMessage: "Trageți aici pentru a agrega",
		pivots: "Etichete de Coloane",
		pivotColumnsEmptyMessage: "Trageți aici pentru a seta etichete de coloane",
		group: "Grup",
		rowDragRow: "rând",
		rowDragRows: "rânduri",
		loadingOoo: "Se încarcă...",
		loadingError: "EROARE",
		noRowsToShow: "Niciun rând de afișat",
		noMatchingRows: "Niciun rând nu se potrivește",
		exportingOoo: "Se exportă...",
		enabled: "Activat",
		pinColumn: "Fixează Coloana",
		pinLeft: "Fixează la Stânga",
		pinRight: "Fixează la Dreapta",
		noPin: "Nu Fixa",
		pinRow: "Fixează rândul",
		pinTop: "Fixează în partea de sus",
		pinBottom: "Fixează în partea de jos",
		unpinRow: "Anulează fixarea rândului",
		valueAggregation: "Agregare Valori",
		noAggregation: "Niciuna",
		autosizeThisColumn: "Redimensionează automat această coloană",
		autosizeAllColumns: "Redimensionează automat toate coloanele",
		groupBy: "Grupează după ${variable}",
		ungroupBy: "Degrupează după ${variable}",
		ungroupAll: "Degrupează tot",
		addToValues: "Adaugă ${variable} la valori",
		removeFromValues: "Elimină ${variable} din valori",
		addToLabels: "Adaugă ${variable} la etichete",
		removeFromLabels: "Elimină ${variable} din etichete",
		resetColumns: "Resetează coloanele",
		expandAll: "Extinde toate grupurile de rânduri",
		collapseAll: "Restrânge toate grupurile de rânduri",
		copy: "Copiază",
		ctrlC: "Ctrl+C",
		ctrlX: "Ctrl+X",
		copyWithHeaders: "Copiază cu Antete",
		copyWithGroupHeaders: "Copiază cu Antete de Grup",
		cut: "Taie",
		paste: "Lipește",
		ctrlV: "Ctrl+V",
		export: "Exportă",
		csvExport: "Exportă CSV",
		excelExport: "Exportă Excel",
		columnFilter: "Filtru de Coloană",
		columnChooser: "Alege Coloane",
		chooseColumns: "Alege Coloane",
		sortAscending: "Sortare Ascendentă",
		sortDescending: "Sortare Descendentă",
		sortAbsoluteAscending: "Sortează în ordine ascendentă absolută",
		sortAbsoluteDescending: "Sortează în ordine descendentă absolută",
		sortUnSort: "Șterge Sortarea",
		shiftF2: "Shift+F2",
		toolbarFind: "Caută",
		toolbarFindPreviousMatch: "Potrivire Anterioară",
		toolbarFindNextMatch: "Potrivire Următoare",
		toolbarQuickFilter: "Filtru",
		toolbarMenu: "Meniu",
		sum: "Sumă",
		first: "Primul",
		last: "Ultimul",
		min: "Minim",
		max: "Maxim",
		none: "Niciunul",
		count: "Numărătoare",
		avg: "Medie",
		filteredRows: "Filtrate",
		selectedRows: "Selectate",
		totalRows: "Total Rânduri",
		totalAndFilteredRows: "Rânduri",
		more: "Mai mult",
		to: "la",
		of: "din",
		page: "Pagină",
		pageLastRowUnknown: "?",
		nextPage: "Pagina Următoare",
		lastPage: "Ultima Pagină",
		firstPage: "Prima Pagină",
		previousPage: "Pagina Anterioară",
		pageSizeSelectorLabel: "Mărime Pagină:",
		footerTotal: "Total",
		statusBarLastRowUnknown: "?",
		scrollColumnIntoView: "Derulează ${variable} în vizualizare",
		pivotColumnGroupTotals: "Total",
		pivotChartAndPivotMode: "Pivot Chart și Modul Pivot",
		pivotChart: "Pivot Chart",
		chartRange: "Interval Grafic",
		columnChart: "Coloană",
		groupedColumn: "Grupat",
		stackedColumn: "Stivuit",
		normalizedColumn: "100% Stivuit",
		barChart: "Bară",
		groupedBar: "Grupat",
		stackedBar: "Stivuit",
		normalizedBar: "100% Stivuit",
		pieChart: "Plăcintă",
		pie: "Plăcintă",
		donut: "Gogoașă",
		lineChart: "Linie",
		stackedLine: "Stivuit",
		normalizedLine: "100% Stivuit",
		xyChart: "X Y (Puncte dispersate)",
		scatter: "Puncte dispersate",
		bubble: "Bule",
		areaChart: "Zonă",
		area: "Zonă",
		stackedArea: "Stivuit",
		normalizedArea: "100% Stivuit",
		histogramChart: "Histogramă",
		polarChart: "Polar",
		radarLine: "Linie Radar",
		radarArea: "Zonă Radar",
		nightingale: "Nightingale",
		radialColumn: "Coloană Radială",
		radialBar: "Bară Radială",
		statisticalChart: "Statistic",
		boxPlot: "Grafic Box",
		rangeBar: "Bară Interval",
		rangeArea: "Zonă Interval",
		hierarchicalChart: "Ierarhic",
		treemap: "Hartă Arbore",
		sunburst: "Explozie Solară",
		specializedChart: "Specializat",
		waterfall: "Cascadă",
		heatmap: "Hartă Termică",
		combinationChart: "Combinată",
		columnLineCombo: "Coloană și Linie",
		AreaColumnCombo: "Zonă și Coloană",
		pivotChartTitle: "Grafic Pivot",
		rangeChartTitle: "Grafic Interval",
		settings: "Setări",
		data: "Date",
		format: "Format",
		categories: "Categorii",
		defaultCategory: "(Niciunul)",
		series: "Serii",
		switchCategorySeries: "Schimbare Categorie / Serii",
		categoryValues: "Valori Categorie",
		seriesLabels: "Etichete Serii",
		aggregate: "Agregat",
		xyValues: "Valori X Y",
		paired: "Mod Pereche",
		axis: "Axă",
		xAxis: "Axă Orizontală",
		yAxis: "Axă Verticală",
		polarAxis: "Axă Polară",
		radiusAxis: "Axă Radius",
		navigator: "Navigator",
		zoom: "Zoom",
		animation: "Animație",
		crosshair: "Reticul",
		color: "Culoare",
		thickness: "Grosime",
		preferredLength: "Lungime preferată",
		xType: "Tip X",
		axisType: "Tip Axă",
		automatic: "Automat",
		category: "Categorie",
		number: "Număr",
		time: "Timp",
		timeFormat: "Format Timp",
		autoRotate: "Rotație automată",
		labelRotation: "Rotație",
		circle: "Cerc",
		polygon: "Poligon",
		square: "Pătrat",
		cross: "Cruce",
		diamond: "Diamant",
		plus: "Plus",
		triangle: "Triunghi",
		heart: "Inimă",
		orientation: "Orientare",
		fixed: "Fix",
		parallel: "Paralel",
		perpendicular: "Perpendicular",
		radiusAxisPosition: "Poziție",
		ticks: "Marcaje",
		gridLines: "Linii Grilă",
		width: "Lățime",
		height: "Înălțime",
		length: "Lungime",
		padding: "Padding",
		spacing: "Spațiere",
		chartStyle: "Stil Grafic",
		title: "Titlu",
		chartTitles: "Titluri",
		chartTitle: "Titlu Grafic",
		chartSubtitle: "Subtitlu",
		horizontalAxisTitle: "Titlu Axă Orizontală",
		verticalAxisTitle: "Titlu Axă Verticală",
		polarAxisTitle: "Titlu Axă Polară",
		titlePlaceholder: "Titlu Grafic",
		background: "Fundal",
		font: "Font",
		weight: "Greutate",
		top: "Deasupra",
		right: "Dreapta",
		bottom: "Dedesubt",
		left: "Stânga",
		labels: "Etichete",
		calloutLabels: "Etichete Apel",
		sectorLabels: "Etichete Sector",
		positionRatio: "Raport Poziție",
		size: "Mărime",
		shape: "Formă",
		minSize: "Mărime Minimă",
		maxSize: "Mărime Maximă",
		legend: "Legendă",
		position: "Poziție",
		markerSize: "Mărime Marcaj",
		markerStroke: "Tușe Marcaj",
		markerPadding: "Padding Marcaj",
		itemSpacing: "Spațiere Elemente",
		itemPaddingX: "Padding Element X",
		itemPaddingY: "Padding Element Y",
		layoutHorizontalSpacing: "Spațiere Orizontală",
		layoutVerticalSpacing: "Spațiere Verticală",
		strokeWidth: "Grosime Linie",
		offset: "Offset",
		offsets: "Offset-uri",
		tooltips: "Tooltip-uri",
		callout: "Apel",
		markers: "Marcaje",
		shadow: "Umbră",
		blur: "Estompare",
		xOffset: "Offset X",
		yOffset: "Offset Y",
		lineWidth: "Grosime Linie",
		lineDash: "Linie Punctată",
		lineDashOffset: "Offset Linie Punctată",
		scrollingZoom: "Defilare",
		scrollingStep: "Pas Defilare",
		selectingZoom: "Selectare",
		durationMillis: "Durată (ms)",
		crosshairLabel: "Etichetă",
		crosshairSnap: "Fixare pe Nod",
		normal: "Normal",
		bold: "Aldin",
		italic: "Italic",
		boldItalic: "Aldin Italic",
		predefined: "Predefinit",
		fillOpacity: "Opacitate Umplere",
		strokeColor: "Culoare Linie",
		strokeOpacity: "Opacitate Linie",
		miniChart: "Mini-Grafic",
		histogramBinCount: "Număr Benzi",
		connectorLine: "Linie Conectare",
		seriesItems: "Elemente Serii",
		seriesItemType: "Tip Element",
		seriesItemPositive: "Pozitiv",
		seriesItemNegative: "Negativ",
		seriesItemLabels: "Etichete Elemente",
		columnGroup: "Coloană",
		barGroup: "Bară",
		pieGroup: "Plăcintă",
		lineGroup: "Linie",
		scatterGroup: "X Y (Dispersie)",
		areaGroup: "Zonă",
		polarGroup: "Polar",
		statisticalGroup: "Statistic",
		hierarchicalGroup: "Ierarhic",
		specializedGroup: "Specializat",
		combinationGroup: "Combinație",
		groupedColumnTooltip: "Grupat",
		stackedColumnTooltip: "Stivuit",
		normalizedColumnTooltip: "100% Stivuit",
		groupedBarTooltip: "Grupat",
		stackedBarTooltip: "Stivuit",
		normalizedBarTooltip: "100% Stivuit",
		pieTooltip: "Plăcintă",
		donutTooltip: "Gogoașă",
		lineTooltip: "Linie",
		stackedLineTooltip: "Stivuit",
		normalizedLineTooltip: "100% Stivuit",
		groupedAreaTooltip: "Grupat",
		stackedAreaTooltip: "Stivuit",
		normalizedAreaTooltip: "100% Stivuit",
		scatterTooltip: "Dispersie",
		bubbleTooltip: "Bulă",
		histogramTooltip: "Histogramă",
		radialColumnTooltip: "Coloană Radială",
		radialBarTooltip: "Bară Radială",
		radarLineTooltip: "Linie Radar",
		radarAreaTooltip: "Zonă Radar",
		nightingaleTooltip: "Nightingale",
		rangeBarTooltip: "Bară Interval",
		rangeAreaTooltip: "Zonă Interval",
		boxPlotTooltip: "Box Plot",
		treemapTooltip: "Hartă Arbore",
		sunburstTooltip: "Sunburst",
		waterfallTooltip: "Cascadă",
		heatmapTooltip: "Hartă Termică",
		columnLineComboTooltip: "Coloană & Linie",
		areaColumnComboTooltip: "Zonă & Coloană",
		customComboTooltip: "Combinație Personalizată",
		innerRadius: "Raza Interioară",
		startAngle: "Unghi de Start",
		endAngle: "Unghi de Sfârșit",
		reverseDirection: "Direcție Inversă",
		groupPadding: "Padding Grup",
		seriesPadding: "Padding Serii",
		tile: "Placă",
		whisker: "Mustață",
		cap: "Capac",
		capLengthRatio: "Raport Lungime Capac",
		labelPlacement: "Plasament Etichetă",
		inside: "În Interior",
		outside: "În Exterior",
		noDataToChart: "Nu sunt date disponibile pentru grafic.",
		pivotChartRequiresPivotMode: "Graficul Pivot necesită activarea Modului Pivot.",
		chartSettingsToolbarTooltip: "Meniu",
		chartLinkToolbarTooltip: "Legat la Grila",
		chartUnlinkToolbarTooltip: "Nelegat de Grilă",
		chartDownloadToolbarTooltip: "Descărcare Grafic",
		chartMenuToolbarTooltip: "Meniu",
		chartEdit: "Editare Grafic",
		chartAdvancedSettings: "Setări Avansate",
		chartLink: "Legare la Grilă",
		chartUnlink: "Dezlegare de Grilă",
		chartDownload: "Descărcare Grafic",
		histogramFrequency: "Frecvență",
		seriesChartType: "Tip Grafic Serii",
		seriesType: "Tip Serii",
		secondaryAxis: "Axă Secundară",
		seriesAdd: "Adăugați o serie",
		categoryAdd: "Adăugați o categorie",
		bar: "Bară",
		column: "Coloană",
		histogram: "Histogramă",
		advancedSettings: "Setări Avansate",
		direction: "Direcție",
		horizontal: "Orizontal",
		vertical: "Vertical",
		seriesGroupType: "Tip Grup",
		groupedSeriesGroupType: "Grupat",
		stackedSeriesGroupType: "Stivuit",
		normalizedSeriesGroupType: "100% Stivuit",
		legendEnabled: "Activat",
		invalidColor: "Valoarea culorii este invalidă",
		groupedColumnFull: "Coloană Grupată",
		stackedColumnFull: "Coloană Stivuită",
		normalizedColumnFull: "Coloană 100% Stivuită",
		groupedBarFull: "Bară Grupată",
		stackedBarFull: "Bară Stivuită",
		normalizedBarFull: "Bară 100% Stivuită",
		stackedAreaFull: "Zonă Stivuită",
		normalizedAreaFull: "Zonă 100% Stivuită",
		customCombo: "Combinație Personalizată",
		funnel: "Pâlnie",
		coneFunnel: "Pâlnie Con",
		pyramid: "Piramidă",
		funnelGroup: "Grup Pâlnie",
		funnelTooltip: "Pâlnie",
		coneFunnelTooltip: "Pâlnie Con",
		pyramidTooltip: "Piramidă",
		dropOff: "Scădere",
		stageLabels: "Etichete Etapă",
		reverse: "Invers",
		tooltipMode: "Mod Tooltip",
		tooltipModeSingle: "Unic",
		tooltipModeShared: "Partajat",
		tooltipModeCompact: "Compact",
		ariaAdvancedFilterBuilderItem: "${variable}. Nivel ${variable}. Apăsați ENTER pentru a edita.",
		ariaAdvancedFilterBuilderItemValidation: "${variable}. Nivel ${variable}. ${variable} Apăsați ENTER pentru a edita.",
		ariaAdvancedFilterBuilderList: "Lista Constructorului de Filtre Avansate",
		ariaAdvancedFilterBuilderFilterItem: "Condiție de Filtrare",
		ariaAdvancedFilterBuilderGroupItem: "Grup de Filtre",
		ariaAdvancedFilterBuilderColumn: "Coloană",
		ariaAdvancedFilterBuilderOption: "Opțiune",
		ariaAdvancedFilterBuilderValueP: "Valoare",
		ariaAdvancedFilterBuilderJoinOperator: "Operator de Îmbinare",
		ariaAdvancedFilterInput: "Intrare Filtru Avansat",
		ariaChecked: "bifat",
		ariaColumn: "Coloană",
		ariaColumnGroup: "Grup de Coloane",
		ariaFilterActive: "Filtru activ",
		ariaColumnFiltered: "Coloană Filtrată",
		ariaColumnSelectAll: "Comută vizibilitatea tuturor coloanelor",
		ariaDateFilterInput: "Intrare Filtru de Dată",
		ariaDefaultListName: "Listă",
		ariaFilterColumnsInput: "Intrare Filtrare Coloane",
		ariaFilterFromValue: "Filtrează de la valoare",
		ariaFilterInput: "Intrare Filtru",
		ariaFilterList: "Listă de Filtre",
		ariaFilterToValue: "Filtrează până la valoare",
		ariaFilterValue: "Valoare Filtrată",
		ariaFilterMenuOpen: "Deschide Meniul Filtrului",
		ariaFilteringOperator: "Operator de Filtrare",
		ariaHidden: "ascuns",
		ariaIndeterminate: "nedeterminat",
		ariaInputEditor: "Editor Intrare",
		ariaMenuColumn: "Apăsați ALT în jos pentru a deschide meniul coloanei",
		ariaFilterColumn: "Apăsați CTRL ENTER pentru a deschide filtrul",
		ariaRowDeselect: "Apăsați SPACE pentru a deselecta acest rând",
		ariaHeaderSelection: "Coloană cu selecție antet",
		ariaSelectAllCells: "Apăsați Space sau Enter pentru a selecta toate celulele",
		ariaSelectAllRowCells: "Apăsați Enter pentru a selecta toate celulele din acest rând",
		ariaColumnCellSelection: "Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din această coloană",
		ariaColumnGroupCellSelection: "Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din acest grup de coloane",
		ariaColumnGroupExpansion: "Apăsați ENTER pentru a extinde sau restrânge acest grup de coloane",
		ariaColumnGroupCellSelectionAndExpansion: "Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din acest grup de coloane. Apăsați ALT ENTER pentru a extinde sau restrânge acest grup de coloane",
		ariaRowSelectAll: "Apăsați Space pentru a comuta selecția tuturor rândurilor",
		ariaRowToggleSelection: "Apăsați Space pentru a comuta selecția rândului",
		ariaRowSelect: "Apăsați SPACE pentru a selecta acest rând",
		ariaRowSelectionDisabled: "Selecția rândului este dezactivată pentru acest rând",
		ariaSearch: "Căutare",
		ariaSortableColumn: "Apăsați ENTER pentru a sorta",
		ariaSortableColumnWithCellSelection: "Apăsați ALT ENTER pentru a sorta",
		ariaToggleVisibility: "Apăsați SPACE pentru a comuta vizibilitatea",
		ariaToggleCellValue: "Apăsați SPACE pentru a comuta valoarea celulei",
		ariaUnchecked: "nebifat",
		ariaVisible: "vizibil",
		ariaSearchFilterValues: "Caută valori ale filtrului",
		ariaPageSizeSelectorLabel: "Dimensiunea Paginii",
		ariaChartMenuClose: "Închide meniul de editare a graficului",
		ariaChartSelected: "Selectat",
		ariaSparklineChartDescription: "Sparkline - ${chartType} afișează ${count} valori între ${min} și ${max}. Începe la ${start} și se termină la ${end}.",
		ariaSparklineChartDescriptionSingleValue: "Sparkline - ${chartType} afișează 1 valoare: ${value}.",
		ariaSparklineChartDescriptionEmpty: "Sparkline - ${chartType} fără valori.",
		ariaSkeletonCellLoadingFailed: "Încărcarea rândului a eșuat",
		ariaSkeletonCellLoading: "Datele rândului se încarcă",
		ariaDeferSkeletonCellLoading: "Celula se încarcă",
		ariaPendingChange: "Modificare în așteptare",
		ariaRowGroupDropZonePanelLabel: "Grupuri de rânduri",
		ariaValuesDropZonePanelLabel: "Valori",
		ariaPivotDropZonePanelLabel: "Etichete de coloană",
		ariaDropZoneColumnComponentDescription: "Apăsați DELETE pentru a elimina",
		ariaDropZoneColumnValueItemDescription: "Apăsați ENTER pentru a schimba tipul de agregare",
		ariaDropZoneColumnGroupItemDescription: "Apăsați ENTER pentru a sorta",
		ariaDropZoneColumnComponentAggFuncSeparator: " din ",
		ariaDropZoneColumnComponentSortAscending: "crescător",
		ariaDropZoneColumnComponentSortDescending: "descrescător",
		ariaDropZoneColumnComponentSortAbsoluteAscending: "ascendent absolut",
		ariaDropZoneColumnComponentSortAbsoluteDescending: "descendent absolut",
		ariaLabelDialog: "Dialog",
		ariaLabelColumnMenu: "Meniu Coloană",
		ariaLabelColumnFilter: "Filtru Coloană",
		ariaLabelSelectField: "Selectează Câmp",
		ariaValidationErrorPrefix: "Validare editor de celule",
		ariaLabelLoadingContextMenu: "Încărcare Meniu Contextual",
		ariaLabelRichSelectField: "Câmp Selectare Avansată",
		ariaLabelRichSelectToggleSelection: "Apăsați SPACE pentru a comuta selecția",
		ariaLabelRichSelectDeselectAllItems: "Apăsați DELETE pentru a deselecta toate elementele",
		ariaLabelRichSelectDeleteSelection: "Apăsați DELETE pentru a deselecta elementul",
		ariaLabelTooltip: "Sugestie",
		ariaLabelContextMenu: "Meniu Contextual",
		ariaLabelSubMenu: "Submeniu",
		ariaLabelAggregationFunction: "Funcția de Agregare",
		ariaLabelAdvancedFilterAutocomplete: "Autocompletare Filtru Avansat",
		ariaLabelAdvancedFilterBuilderAddField: "Constructor Filtru Avansat - Adăugare Câmp",
		ariaLabelAdvancedFilterBuilderColumnSelectField: "Constructor Filtru Avansat - Selectare Coloană Câmp",
		ariaLabelAdvancedFilterBuilderOptionSelectField: "Constructor Filtru Avansat - Selectare Opțiune Câmp",
		ariaLabelAdvancedFilterBuilderJoinSelectField: "Constructor Filtru Avansat - Selectare Operator De Unire Câmp",
		ariaColumnPanelList: "Listă de coloane",
		ariaFilterPanelList: "Listă de filtre",
		ariaLabelAddFilterField: "Adaugă Câmp de Filtrare",
		ariaLabelFilterCardDelete: "Șterge Filtrul",
		ariaLabelFilterCardHasEdits: "Are Modificări",
		ariaHasNote: "Această celulă are o notă.",
		thousandSeparator: ",",
		decimalSeparator: ".",
		true: "Adevărat",
		false: "Fals",
		invalidDate: "Dată invalidă",
		invalidNumber: "Număr invalid",
		invalidBigInt: "BigInt invalid",
		january: "Ianuarie",
		february: "Februarie",
		march: "Martie",
		april: "Aprilie",
		may: "Mai",
		june: "Iunie",
		july: "Iulie",
		august: "August",
		september: "Septembrie",
		october: "Octombrie",
		november: "Noiembrie",
		december: "Decembrie",
		year: "An",
		quarter: "Trimestru",
		month: "Lună",
		day: "Zi",
		hour: "Oră",
		minute: "Minut",
		second: "Secundă",
		timeFormatSlashesDDMMYYYY: "ZZ/LL/AAAA",
		timeFormatSlashesMMDDYYYY: "LL/ZZ/AAAA",
		timeFormatSlashesDDMMYY: "ZZ/LL/AA",
		timeFormatSlashesMMDDYY: "LL/ZZ/AA",
		timeFormatDotsDDMYY: "ZZ.L.AA",
		timeFormatDotsMDDYY: "L.ZZ.AA",
		timeFormatDashesYYYYMMDD: "AAAA-LL-ZZ",
		timeFormatSpacesDDMMMMYYYY: "ZZ LLLL AAAA",
		timeFormatHHMMSS: "OO:MM:SS",
		timeFormatHHMMSSAmPm: "OO:MM:SS AM/PM",
		note: "Notă celulă",
		addNote: "Adaugă notă",
		viewNote: "Vizualizează nota",
		editNote: "Editează nota",
		deleteNote: "Elimină nota",
		notePlaceholder: "Adaugă o notă..."
	},
	ru: {
		selectAll: "Выбрать все",
		selectAllSearchResults: "Выбрать все результаты поиска",
		addFilter: "Добавить фильтр",
		clearFilter: "Очистить фильтр",
		applyFilter: "Применить фильтр",
		resetFilter: "Сбросить",
		searchOoo: "Поиск...",
		equals: "Равно",
		notEqual: "Не равно",
		lessThan: "Меньше чем",
		greaterThan: "Больше чем",
		greaterThanOrEqual: "Больше или равно",
		lessThanOrEqual: "Меньше или равно",
		inRange: "В диапазоне",
		inRangeStart: "В диапазоне (начало)",
		inRangeEnd: "В диапазоне (конец)",
		contains: "Содержит",
		notContains: "Не содержит",
		startsWith: "Начинается с",
		endsWith: "Заканчивается на",
		before: "До",
		after: "После",
		andCondition: "И",
		orCondition: "Или",
		and: "И",
		or: "Или",
		not: "Не",
		is: "Является",
		isNot: "Не является",
		isEmpty: "Пусто",
		isNotEmpty: "Не пусто",
		isNull: "NULL",
		isNotNull: "Не NULL",
		isBlank: "Пусто",
		isNotBlank: "Не пусто",
		filterOoo: "Фильтр...",
		blanks: "Пустые значения",
		blank: "Пустое значение",
		notBlank: "Не пустое значение",
		dateFormatOoo: "yyyy-mm-dd",
		copy: "Копировать",
		paste: "Вставить",
		export: "Экспорт",
		csvExport: "Экспорт CSV",
		excelExport: "Экспорт Excel",
		pageSizeSelectorLabel: "Размер страницы",
		page: "Страница",
		more: "Больше",
		to: "до",
		of: "из",
		next: "Следующая",
		last: "Последняя",
		first: "Первая",
		previous: "Предыдущая",
		loadingOoo: "Загрузка...",
		columns: "Столбцы",
		filters: "Фильтры",
		group: "Группа",
		rowGroupColumnsEmptyMessage: "Перетащите сюда столбцы для группировки",
		valueColumnsEmptyMessage: "Перетащите сюда столбцы для значений",
		noRowsToShow: "Нет данных для отображения",
		pinColumn: "Закрепить столбец",
		autosizeThiscolumn: "Автоматический размер",
		resetColumns: "Сбросить столбцы",
		expandAll: "Развернуть все",
		collapseAll: "Свернуть все",
		sum: "Сумма",
		min: "Минимум",
		max: "Максимум",
		none: "Нет",
		count: "Количество",
		avg: "Среднее"
	},
	sk: tt,
	sv: et,
	tr: nt,
	uk: rt,
	ur: Ze,
	uz: {
		selectAll: "Hammasini tanlash",
		selectAllSearchResults: "Qidiruv natijalarini tanlash",
		addFilter: "Filtr qo‘shish",
		clearFilter: "Filtrni tozalash",
		applyFilter: "Filtrni qo‘llash",
		resetFilter: "Tiklash",
		searchOoo: "Qidiruv...",
		equals: "Teng",
		notEqual: "Teng emas",
		lessThan: "Kichikroq",
		greaterThan: "Kattaroq",
		lessThanOrEqual: "Kichik yoki teng",
		greaterThanOrEqual: "Katta yoki teng",
		inRange: "Diapazonda",
		inRangeStart: "Diapazonda (bosh)",
		inRangeEnd: "Diapazonda (oxir)",
		contains: "O‘z ichiga oladi",
		notContains: "O‘z ichiga olmaydi",
		startsWith: "Boshida",
		endsWith: "Tugada",
		before: "Oldin",
		after: "Keyin",
		andCondition: "Va",
		orCondition: "Yoki",
		and: "Va",
		or: "Yoki",
		not: "Yo‘q",
		is: "Ijobiy",
		isNot: "Manfiy",
		isEmpty: "Bo‘sh",
		isNotEmpty: "Bo‘sh emas",
		isNull: "NULL",
		isNotNull: "NULL emas",
		isBlank: "Bo‘sh",
		isNotBlank: "Bo‘sh emas",
		filterOoo: "Filtr...",
		blanks: "Bo‘sh joylar",
		blank: "Bo‘sh joy",
		notBlank: "Bo‘sh joy emas",
		dateFormatOoo: "yyyy-mm-dd",
		copy: "Nusxa olish",
		paste: "Joylashtirish",
		export: "Eksport",
		csvExport: "CSV eksport",
		excelExport: "Excel eksport",
		pageSizeSelectorLabel: "Sahifa o‘lchami",
		page: "Sahifa",
		more: "Ko‘proq",
		to: "dan",
		of: "jami",
		next: "Keyingi",
		last: "Oxirgi",
		first: "Birinchi",
		previous: "Oldingi",
		loadingOoo: "Yuklanmoqda...",
		columns: "Ustunlar",
		filters: "Filtrlar",
		group: "Guruh",
		rowGroupColumnsEmptyMessage: "Guruhlash uchun ustunni shu yerga torting",
		valueColumnsEmptyMessage: "Qiymatlar uchun ustunni shu yerga torting",
		noRowsToShow: "Ko‘rsatish uchun ma’lumot yo‘q",
		pinColumn: "Ustunni mahkamlash",
		autosizeThiscolumn: "Ustunni avtomatik o‘lchash",
		resetColumns: "Ustunlarni tiklash",
		expandAll: "Barchasini yoyish",
		collapseAll: "Barchasini yig‘ish",
		sum: "Yig‘indi",
		min: "Minimum",
		max: "Maksimum",
		none: "Yo‘q",
		count: "Soni",
		avg: "O‘rtacha"
	},
	vi: it,
	zh: Ne
}, At = (e) => e ? kt[e] : void 0, jt = () => /* @__PURE__ */ Q(Z, { name: "search" }), Mt = ({ view: t, enumerations: n, language: i, style: a, className: o, templateConfig: s }) => {
	let c = U(s);
	c.current = s;
	let l = H(() => ne(() => c.current), []), d = U(void 0), [f, p] = W(() => ke(t) ? ut(t.columns, n) : void 0), [m, h] = W(!1), [g, _] = W(r), [v, y] = W(!1), b = U(!0), x = e(), { pageNumber: S, totalNumberOfRows: C, pagedTasks: w, setFilters: T, setSort: E, onKeywordChange: ee, onPageNumberChange: D, onSelectedTaskChanged: O, selectedTaskWithDetails: A, selectedTasks: te, setSelectedTasks: j, onBulkTaskActionUpdate: M, searchBulkAssignees: N } = St(t, n, g, l), P = q(K.Input), L = q(K.Table), re = q(K.TableHeader), ie = q(K.Modal), R = H(() => w[S] || [], [w, S]), ae = H(() => gt(R), [R]), V = t?.rowSelectionEnabled ?? !0, oe = H(() => V ? { mode: "multiRow" } : void 0, [V]), J = !a?.height || a.height === "auto", Y = H(() => ({
		localeText: At(i),
		...J ? { domLayout: "autoHeight" } : {}
	}), [i, J]), se = (e) => {
		d.current = e.api;
	}, ce = z(({ newPage: e, newPageSize: t }) => {
		if (d.current && t ? l.pageSizeChanged() : d.current && e && l.paged(d.current.paginationGetCurrentPage()), d.current && e) {
			let e = d.current.paginationGetCurrentPage();
			D(e);
		}
		d.current && t && _(d.current.paginationGetPageSize());
	}, [D, l]), le = z((e) => {
		let n = ht(e.api.getFilterModel(), t?.columns);
		T(n), e.source === "api" ? l.gridReset(e.api.getFilterModel()) : l.filtered(e.api.getFilterModel(), (t) => e.api.getColumn(t)?.getColDef().headerName), D(0);
	}, [
		t,
		T,
		D,
		l
	]), ue = z((e) => {
		let t = e?.columns?.find((e) => e.getSort()) ?? e?.columns?.[0];
		e?.source !== "gridOptionsChanged" && l.sorted(t?.getColDef().headerName, t?.getSort());
		let n = F(e.api);
		p((e) => e?.map((e) => {
			let t = n.find(({ colId: t }) => t === e.field);
			return {
				...e,
				sort: t?.sort ?? null,
				sortIndex: t?.sortIndex ?? null
			};
		})), E(I(n));
	}, [E, l]), de = z((e) => {
		e.rowIndex !== null && (l.taskOpened(R[e.rowIndex - S * g]?.processInstance?.processState), j([]), d.current?.deselectAll(), O(e.rowIndex), h(!0));
	}, [
		O,
		R,
		S,
		g,
		l
	]), me = z((e) => {
		let t = e.api.getSelectedRows().map(({ agGridId: e }) => e), n = R.filter(({ tokenUuid: e }) => t.includes(e));
		j(n);
	}, [R]), he = z((e, t) => {
		y(!0), M(e, t).then(() => {
			y(!1);
		}), d.current?.deselectAll();
	}, [M]), ge = w[0] !== void 0;
	return B(() => {
		ge && l.opened();
	}, [ge, l]), B(() => {
		if (!d.current || isNaN(S)) return;
		let e = d.current.paginationGetCurrentPage();
		S !== e && d.current.paginationGoToPage(S);
	}, [S]), B(() => {
		if (b.current) {
			b.current = !1;
			return;
		}
		ke(t) && p(ut(t.columns, n));
	}, [t, n]), /* @__PURE__ */ $(Ee, { children: [/* @__PURE__ */ $("div", {
		className: G("flx-task-management-container", o),
		style: a,
		children: [
			/* @__PURE__ */ Q("div", {
				className: "flx-task-search",
				children: /* @__PURE__ */ Q(fe, {
					className: G(P, "flx-search-input"),
					children: /* @__PURE__ */ Q(be, {
						prefixIcon: jt,
						children: /* @__PURE__ */ Q(X, {
							placeholder: `${k("@@sys_search")}...`,
							onChange: (e) => ee(e.target.value)
						})
					})
				})
			}),
			V ? /* @__PURE__ */ Q(Ot, {
				tasks: te,
				onUpdateTasks: he,
				searchUsers: N
			}) : null,
			/* @__PURE__ */ Q("div", {
				className: "flx-table-wrapper",
				children: /* @__PURE__ */ Q(Te, {
					gridOptions: Y,
					isServerSide: !0,
					totalNumberOfRows: C,
					rowData: ae,
					columnDefs: f,
					onPaginationChanged: ce,
					paginationPageSize: g,
					onFilterChanged: le,
					onSortChanged: ue,
					onGridReady: se,
					onRowClicked: de,
					onSelectionChanged: me,
					selection: oe,
					className: G("ag-theme-quartz", L, re, "flx-table"),
					paginationPageSizeSelector: u
				})
			}),
			v && /* @__PURE__ */ Q("div", {
				className: "background-loader",
				children: /* @__PURE__ */ Q(_e, {
					backgroundColor: "#ffffff",
					borderColor: "transparent",
					visualType: "custom",
					size: "custom",
					radius: 90
				})
			})
		]
	}), A?.task && /* @__PURE__ */ Q(pe, {
		onOpenChange: (e) => {
			e || (O(-1), h(e));
		},
		open: m,
		dismissible: !0,
		className: G(ie, "flx-task-details-modal"),
		container: x,
		children: /* @__PURE__ */ Q(Et, {
			task: A.task,
			details: A.details,
			searchAssignees: A.searchAssignees,
			onActionUpdate: A.onActionUpdate,
			onPriorityUpdate: A.onPriorityUpdate,
			onViewApplication: A.onViewApplication,
			onCommentDelete: A.onCommentDelete,
			onCommentCreate: A.onCommentCreate
		})
	})] });
}, Nt = ({ style: e, className: t, templateConfig: n, accessToken: r, authToken: i, anonymousSessionId: a, language: o, themeId: s, baseUrl: c, apiUrl: l, locale: u, assetsBaseUrl: d, staticAssetsPath: f, appInfo: m, buildId: h, workspaceId: g, legacyHttpVersion: _, fw: v, viewId: y, cache: b, stages: x }) => {
	let { apiUrl: S, staticAssetsPath: C, authToken: w } = at({
		baseUrl: c,
		apiUrl: l,
		assetsBaseUrl: d,
		staticAssetsPath: f,
		accessToken: r,
		authToken: i
	}), [T, E] = W(), [ee, O] = W({}), [k, A] = W(!1), te = H(() => ({
		authToken: w,
		anonymousSessionId: a,
		language: o,
		themeId: s,
		apiUrl: S,
		locale: u,
		staticAssetsPath: C,
		appInfo: m,
		buildId: h,
		workspaceId: g,
		legacyHttpVersion: _,
		fw: v,
		viewId: y,
		cache: b,
		stages: x
	}), [
		w,
		a,
		o,
		s,
		S,
		u,
		C,
		m,
		h,
		g,
		_,
		v,
		y,
		b,
		x
	]);
	return B(() => {
		D(te).then(({ view: e, enumerations: t }) => {
			E(e), O(t), A(!0);
		});
	}, [te]), V(() => {
		w && p() && P(w);
	}, [w]), B(() => () => j(), []), !k || !T ? /* @__PURE__ */ Q(pe, {
		defaultOpen: !0,
		style: {
			backgroundColor: "transparent",
			boxShadow: "none"
		},
		children: /* @__PURE__ */ Q(_e, {
			backgroundColor: "#ffffff",
			borderColor: "transparent",
			visualType: "custom",
			size: "custom",
			radius: 90
		})
	}) : /* @__PURE__ */ Q(Mt, {
		view: T,
		enumerations: ee,
		language: o,
		style: e,
		className: t,
		templateConfig: n
	});
};
//#endregion
export { At as n, at as r, Nt as t };
